import * as React from 'react'
import { cn } from '@/lib/utils'

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'default' | 'narrow' | 'medium' | 'wide'
}

const sizeMap = {
  narrow:  'max-w-[760px] px-6',
  medium:  'max-w-[1024px] px-6 md:px-12',
  default: 'max-w-container px-6 md:px-12',
  wide:    'max-w-[1600px] px-6 md:px-12',
}

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, size = 'default', ...props }, ref) => (
    <div ref={ref} className={cn('mx-auto w-full', sizeMap[size], className)} {...props} />
  ),
)
Container.displayName = 'Container'
